export const DELETE_TITLE = 'Excluir Turno';
export const DELETE_MESSAGE = 'Você está prestes a excluir o registro de <b>Turno</b>. Uma vez feita esta ação não poderá ser desfeita. Você tem certeza de que deseja excluir este registro?';
export const DELETE_CONFIRM_TEXT = 'Sim, desejo excluir o Turno';
export const DELETE_SUCCESS_MESSAGE = 'Turno excluído com sucesso';
export const INTERVAL_TYPES = {
  fixed: 'F',
  variable: 'V',
};
